import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import Row from 'react-bootstrap/lib/Row';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import CurrencyConverter from '../../CurrencyConverter';
import renderTooltip from '../../../components/siteadmin/SiteSettingsForm/toolTipHelper.js';
import messages from '../../../locale/messages';
import { getCalculationDetails } from '../../../helpers/Pricing/getCalculationDetails.js';
import s from './Calendar.css';
class BillDetails extends Component {
    static propTypes = {
        basePrice: PropTypes.number.isRequired,
        cleaningPrice: PropTypes.number,
        tax: PropTypes.number,
        currency: PropTypes.string.isRequired,
        monthlyDiscount: PropTypes.number,
        weeklyDiscount: PropTypes.number,
        startDate: PropTypes.object.isRequired,
        endDate: PropTypes.object.isRequired,
        serviceFees: PropTypes.shape({
            guest: PropTypes.shape({
                type: PropTypes.string.isRequired,
                value: PropTypes.number.isRequired,
                currency: PropTypes.string.isRequired
            }).isRequired
        }).isRequired,
        base: PropTypes.string.isRequired,
        rates: PropTypes.object.isRequired,
        formatMessage: PropTypes.any,
        specialPricing: PropTypes.array,
    };

    static defaultProps = {
        basePrice: 0, cleaningPrice: 0, tax: 0, monthlyDiscount: 0, weeklyDiscount: 0,
        startDate: null, endDate: null, specialPricing: [],
    }

    render() {
        const { tax, currency, endDate, serviceFees, base, rates, specialPricing, change, toCurrency } = this.props;
        const { startDate, basePrice, cleaningPrice, monthlyDiscount, weeklyDiscount, petFee } = this.props;
        const { formatMessage } = this.props.intl;
        const { taxes, isSpecialPriceAssigned, guestServiceFee, hostServiceFee,
            priceForDays, isAverage, total, discount, dayDifference, discountType
        } = getCalculationDetails({
            startDate, basePrice, cleaningPrice, monthlyDiscount, weeklyDiscount, formatMessage,
            serviceFees, specialPricing, toCurrency, tax, currency, endDate, base, rates, petFee
        });

        change("BookingForm", 'isHostServiceEligible', hostServiceFee > priceForDays ? true : false);
        if (isAverage) {
            change("BookingForm", 'averageBasePrice', isAverage);
        }

        return (
            <FormGroup className={s.noMargin}>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} className={'viewListingCalender'}>
                        <div className={cx('paymentDetailsFlex', s.billdetail)}>
                            <div className={cx(s.noBorder, 'paymentDetailsFlexLeft')}>
                                {
                                    isSpecialPriceAssigned &&
                                    <div className='tooltipFlex'>
                                        <>{renderTooltip(formatMessage(messages.averagePricePerNight), 'commonTooltipIcon')}</>
                                        <div className={cx(s.specialPriceText, 'directionLtr')}>
                                            <CurrencyConverter
                                                amount={isAverage}
                                                from={currency}
                                            />
                                            {' x'} {dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
                                        </div>
                                    </div>
                                }
                                {
                                    !isSpecialPriceAssigned && <div className={cx(s.specialPriceText, 'directionLtr')}>
                                        <CurrencyConverter
                                            amount={isAverage}
                                            from={currency}
                                        />
                                        {' x'} {dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
                                    </div>
                                }
                            </div>
                            <div className={'paymentDetailsFlexRight'}>
                                <CurrencyConverter
                                    amount={priceForDays}
                                    from={currency}
                                />
                            </div>
                        </div>
                        {
                            discount > 0 &&
                            <div className={cx('paymentDetailsFlex', s.billdetail)}>
                                <div className={'paymentDetailsFlexLeft'}>{discountType}</div>
                                <div className={cx('paymentDetailsFlexRight', s.discountText)}>
                                    <span>- </span>
                                    <span className={cx(s.displayCell, s.priceCss)}>
                                        <CurrencyConverter
                                            amount={discount}
                                            from={currency}
                                        />
                                    </span>
                                </div>
                            </div>
                        }
                        {
                            cleaningPrice > 0 &&
                            <div className={cx('paymentDetailsFlex', s.billdetail)}>
                                <div className={'paymentDetailsFlexLeft'}><FormattedMessage {...messages.cleaningFee} /></div>
                                <div className={cx('paymentDetailsFlexRight')}>
                                    <CurrencyConverter
                                        amount={cleaningPrice}
                                        from={currency}
                                    />
                                </div>
                            </div>
                        }
                        {
                            guestServiceFee > 0 && <div className={cx('paymentDetailsFlex', s.billdetail)}>
                                <div className={'paymentDetailsFlexLeft'}><FormattedMessage {...messages.serviceFee} /></div>
                                <div className={'paymentDetailsFlexRight'}>
                                    <CurrencyConverter
                                        amount={guestServiceFee}
                                        from={currency}
                                    />
                                </div>
                            </div>
                        }
                        {
                            petFee > 0 && <div className={cx('paymentDetailsFlex', s.billdetail)}>
                                <div className={'paymentDetailsFlexLeft'}><FormattedMessage {...messages.petFee} /></div>
                                <div className={'paymentDetailsFlexRight'}>
                                    <CurrencyConverter
                                        amount={petFee}
                                        from={currency}
                                    />
                                </div>
                            </div>
                        }
                        {
                            taxes > 0 && <div className={cx('paymentDetailsFlex', s.billdetail)}>
                                <div className={'paymentDetailsFlexLeft'}><FormattedMessage {...messages.tax} /> {`(${tax.toFixed(2)}%)`}</div>
                                <div className={'paymentDetailsFlexRight'}>
                                    <CurrencyConverter
                                        amount={taxes}
                                        from={currency}
                                    />
                                </div>
                            </div>
                        }
                        <div className={cx('paymentDetailsFlex', s.billdetail, s.totalBorderTop)}>
                            <div className={cx(s.totalText, 'paymentDetailsFlexLeft')}><FormattedMessage {...messages.total} /></div>
                            <div className={cx(s.totalText, 'paymentDetailsFlexRight')}>
                                <CurrencyConverter
                                    amount={total}
                                    from={currency}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </FormGroup>
        );
    }
}

const mapState = (state) => ({
    specialPricing: state.viewListing.specialPricing,
    toCurrency: state.currency.to || state.currency.base,
});

const mapDispatch = {
    change
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(BillDetails)));